<script setup lang="ts">
const {
  public: {baseUrl},
} = useRuntimeConfig()

const {fetch} = useCompany()

const {data: initialData} = await useAsyncData('company', () => fetch())
const {data: company} = useLivePreview({initialData: initialData.value, depth: 3})

if (!company.value) {
  throw createError({status: 503, message: 'Could not load the page.'})
}

const meta = company.value?.meta

useSeoMeta({
  title: meta?.title,
  description: meta?.description,
  ogUrl: `${baseUrl}/company`,
  ogTitle: meta?.ogTitle || meta?.title,
  ogDescription: meta?.ogDescription || meta?.description,
  ogImage: resolveMediaUrl(meta?.image),
  ogImageAlt: resolveMediaAlt(meta?.image),
})
</script>

<template>
  <main v-if="company" class="flex w-full flex-col overflow-hidden">
    <AboutUsHero :headline="company.headline ?? ''" :image-grid="company.imageGrid" />
    <AboutUsStats v-if="company.stats" :data="company.stats" />

    <Container v-if="company.content" class="screen-content">
      <RichText
        :raw="company.content"
        class="content-company mx-auto max-w-screen-sm !py-8 leading-snug !text-gray-600 prose-h2:text-base prose-h2:!font-medium prose-h2:!text-gray-600"
      />
    </Container>
    <AboutUsQuoteCard v-if="company.quote" :data="company.quote" />
    <AboutUsTeam v-if="company.ourTeam" :data="company.ourTeam" />
    <Container class="h-32" />
  </main>
</template>
